import { Spin } from 'antd';
import type { ReactNode } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { LoginPage } from '../../pages/LoginPage';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <Spin fullscreen />;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
